export const isProduction = process.env.NEXT_PUBLIC_ENV === "production";
export const isStaging = process.env.NEXT_PUBLIC_ENV === "staging";
export const isDevelopment = process.env.NEXT_PUBLIC_ENV === "development";
export const isTest = process.env.NEXT_PUBLIC_ENV === "test";
